import type { ReactNode } from 'react';

import { BottomBar, cn, useResponsive } from '@yummy/ui-rnr';

/**
 * The footer bar this app's screens use.
 *
 * The kit's `BottomBar` reserves space along the bottom for a home indicator.
 * On a phone there is no need: the shell already has a tab bar sitting below
 * the footer, so the reserved space is empty and everything in the bar reads as
 * sitting high. On a tablet the tab bar is gone and the space is real.
 *
 * One place rather than one condition per screen. Every footer here carried the
 * same unconditional padding and the same few pixels of drift, because each
 * screen solved the same problem separately — which is how the footers drifted
 * apart from each other in the first place.
 *
 * @param props The footer's content, and any classes the screen needs to add.
 * @returns A footer bar, padded for the layout it is in.
 */
export function FooterBar({ children, className }: { children: ReactNode; className?: string }) {
  const { isTablet } = useResponsive();

  return (
    <BottomBar className={cn(isTablet ? undefined : 'py-3', className)}>{children}</BottomBar>
  );
}
